module.exports = __webpack_public_path__ + "static/real-1603a237b4d3c41b922d2f88e327e6f3.svg";